export const CHECKOUT_PLACECASH_BANNER = 'checkout.placeCashBanner';

const ProgressBarlabels = {
  checkout: {
    placeCashBanner: {
      lbl_placeCash_progress_US_before_cartAmount: 'You are only ',
      lbl_placeCash_progress_US_between_amount: ' away from your next ',
      lbl_placeCash_progress_US_place_bucks: ' PLACE Bucks',
      lbl_placeCash_progress_US_after_bucks: ' coupon ',
      lbl_placeCash_to_use: ' to use ',
      lbl_placereward_us_progress_before_points: 'Click Check Balance Button',
      lbl_placereward_us_progress_title2: ' point(s) away from earning another ',
      lbl_placereward_us_progress_after_points: ' Reward!',
      lbl_placereward_us_progress_reward_value: '$5',
    },
  },
};

export default ProgressBarlabels;
